var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"mapRightRef",staticClass:"mapRight",attrs:{"id":"mapRightId"}},[_c('subMap',{ref:"subMap",attrs:{"layer-name":_vm.layerName,"rules":_vm.rules,"layer-code":_vm.layerCode},on:{"setLocation":_vm.setLocation}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }